import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { securityService } from "services/SecurityService";
import { User } from "types";

const name: string = "users.action";

interface usersState {
  users: User[];
  error: string | null;
  loading: Boolean;
}

const initialState: usersState = {
  users: [],
  error: null,
  loading: false,
};

export const getUsers = createAsyncThunk<User[]>(
  `${name}/GetUsers`,
  async (): Promise<User[]> => await securityService.getUsers()
);

export const usersSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getUsers.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getUsers.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.users = payload;
    });

    builder.addCase(getUsers.rejected, (state) => {
      state.loading = false;
      state.error = "error getting users";
    });
  },
  reducers: {
    switchStatus: (state, { payload }) => {
      state.users = state.users.map((user) => {
        if (user.userID === payload.userID) {
          user.isActive = !!payload.isActive;
        }
        return user;
      });
    },
  },
});

export const { switchStatus } = usersSlice.actions;

export default usersSlice.reducer;
